export { default } from './CustomerGarageHeader.container';
